import * as Sentry from '@sentry/vue'
import { FetchError } from 'ofetch'
import getCurrentHost from '~/utils/api-utils'

export type PaymentType = keyof typeof PAYMENT_TYPE_ICON

// See AllowedPayment Types https://customer-api.eks-eu-central-1-private.int.billing.ridedev.io/api-docs/webjars/swagger-ui/index.html?configUrl=%2Fapi-docs%2Fv3%2Fopenapi%2Fswagger-config&urls.primaryName=customer#/
// Can be a mix of paymentTypes and creditcardTypes
export const PAYMENT_TYPE_ICON = {
  PAYPAL: 'payment_paypal',
  INVOICE: 'payment_filled',
  WITHDRAWAL: 'payment_filled',
  VISA: 'payment_visa',
  AMEX: 'payment_amex',
  MASTERCARD: 'payment_mastercard',
  IDEAL: 'payment_ideal',
  SOFORT: 'payment_sofort',
  GIROPAY: 'payment_giropay',
  STRIPE_SEPA: 'payment_filled',
  DISCOVER: 'payment_discover',
  DINERS_CLUB: 'payment_dinersclub',
  DIRECTDEBIT: 'payment_debit',
  PARTNER: 'payment_filled',
  EPS: 'payment_eps',
  MOBILE_PAY: 'payment_mobile_pay',
  APPLE_PAY: 'payment_apple_pay',
  GOOGLE_PAY: 'payment_google_pay',
}

export interface PaymentProfile {
  paymentProfileId: number
  profileName: string
  defaultProfile: boolean
  usable: boolean
  type: 'PRIVATE' | 'BUSINESS' | 'SERVICE'
  eligibleLegalEntities: number[]
  valid: boolean
  payment: {
    type: string
    number?: string
  } | null
}

export interface PaymentProfilesResponse {
  body: {
    paymentProfiles: PaymentProfile[]
  }
}

export function usePaymentApi() {
  const apiBase: string = '/api/billing/customer'

  const getPaymentProfileSummary = async (token: string) => {
    try {
      return await $fetch<PaymentProfilesResponse>(`${apiBase}/payment-profile-summary`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        baseURL: getCurrentHost(),
      })
    }
    catch (error: unknown) {
      if (error instanceof FetchError) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          Sentry.captureMessage(`Authorization error while fetching payment profiles: ${error.message}`, 'error')
          return null
        }
        else if (error.response?.status === 404) {
          Sentry.captureMessage(`Not Found Error while fetching payment profiles: ${error.message}`, 'error')
        }
      }
      Sentry.captureException(error)
      return null
    }
  }
  return {
    getPaymentProfileSummary,
  }
}
